export default __webpack_public_path__ + "static/clusterbuild2-8f1fd4f018a125c34fb4ea63576b9a69.png";